import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import {useFiltersStore} from "@/store/SerpPage/FiltersStore";
import {toRefs, inject} from "vue";


import { SmartSearchTranslationsInterface} from "@/core/types";

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion

export default /*@__PURE__*/_defineComponent({
  __name: 'ClearFiltersButton',
  setup(__props) {

const filtersStore = useFiltersStore()
const {hasSelectedFilters} = toRefs(filtersStore)
const SmartSearchTranslations = inject<SmartSearchTranslationsInterface>('SmartSearchTranslations')!



return (_ctx: any,_cache: any) => {
  return (_unref(hasSelectedFilters))
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        type: "button",
        class: "serp__filter--clear-button q-btn q-btn-sm q-btn-danger q-mb-3 q-rounded-3 q-shadow-sm",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(filtersStore).clearSelectedFilters && _unref(filtersStore).clearSelectedFilters(...args)))
      }, _toDisplayString(_unref(SmartSearchTranslations).filters.clear), 1))
    : _createCommentVNode("", true)
}
}

})